import { render, staticRenderFns } from "./DefSearch.vue?vue&type=template&id=5c984012&"
import script from "./DefSearch.vue?vue&type=script&lang=js&"
export * from "./DefSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports